<template>
  <div v-if="model">
    <span>
      <u>
        <a
          v-popover.right="{
            title: model.strengthItemDisplayTitle,
            content: model.strengthItemShortDefinition,
          }"
          class="a-minorAction showPopover"
          href="javascript:void(0)"
          >{{ model.strengthItemDisplayTitle }}</a
        > </u
      >:
      <template v-if="model.lastDayIndex > 0">
        Day {{ model.lastDayIndex }} -
        <span v-if="model.lastReadActionTime" class="text-muted">
          {{ displayDate(model.lastReadActionTime) }}
        </span>
      </template>
      <span v-else class="text-muted">not started</span>
    </span>
    <br />
  </div>
</template>

<script setup lang="ts">
import moment from "dayjs";
import { popover as vPopover } from "uiv";
import { DevelopStrengthProgressApiModel } from "../../api-models";

const props = defineProps<{
  model: DevelopStrengthProgressApiModel;
}>();

const displayDate = (dateString: string): string => {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : "";
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>
